export const AUTH_ACCESS_TOKEN = "kaylo-access-token";
export const SW_CONTEXT_TOKEN = "sw-context-token";
